<template lang="html">
  <div>
    <h1 style="text-align:center; font-size:2.3em; " class="mt-4">จัดการข้อมูลวาระการประชุมครั้งที่ 2 ปี 2018</h1>
    <v-dialog v-model="dialog" max-width="500px">
      <v-btn slot="activator" color="primary" dark class="mb-3">เพิ่มวาระ</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.agenda_index" label="วาระที่" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.agenda" label="วาระย่อย"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="editedItem.title" label="ชื่อวาระ" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="editedItem.short_title" label="ชื่อวาระย่อ" hint="ใช้สำหรับพิมพ์ชื่อวาระที่มีความยาวเกินไป"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <h2>รูปภาพ</h2>
                <v-btn raised class="primary" @click="onPickFile">Upload Image</v-btn>
                <input type="file" style="display: none" ref="fileInput" accept="image/*" @change="onFilePicked">
              </v-flex>
              <v-flex xs12 sm6>
                <img :src="imageUrl" height="80">
              </v-flex>
              <v-flex xs12>
                <h2>การนับคะแนน</h2>
                <v-radio-group v-model="radios" :mandatory="false">
                  <v-radio label="เสียงข้างมาก" value="radio-1"></v-radio>
                  <v-radio label="เสียงไม่น้อยกว่าสามในสี่" value="radio-2"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table :headers="headers" :items="agendaList" class="elevation-1">
    <template slot="items" slot-scope="props">
      <td>{{ props.item.agenda_index }}.{{ props.item.agenda}}</td>
      <td class="text-xs-left">{{ props.item.title }}</td>
      <!-- <td class="text-xs-right">{{ props.item.shortname }}</td>
      <td class="text-xs-right">{{ props.item.carbs }}</td>
      <td class="text-xs-right">{{ props.item.protein }}</td> -->
      <td class="justify-right layout px-0">
        <v-btn icon class="mx-0" @click="editItem(props.item)">
          <v-icon color="teal">edit</v-icon>
        </v-btn>
        <v-btn icon class="mx-0" @click="deleteItem(props.item)">
          <v-icon color="pink">delete</v-icon>
        </v-btn>
      </td>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
    <template slot="pageText" slot-scope="props">
      Lignes {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
    </template>
  </v-data-table>
</div>
</template>

<script>
import { Decode } from '@/services'
export default {
  data: () => ({
    imageUrl: '',
    image: null,
    radios: 'radio-1',
    dialog: false,
    headers: [
      { text: 'วาระที่', align: 'left', sortable: false },
      { text: 'ชื่อวาระ', value: 'agendaname', sortable: false },
      // { text: 'shortname (g)', value: 'shortname', sortable: false },
      // { text: 'Carbs (g)', value: 'carbs', sortable: false },
      // { text: 'Protein (g)', value: 'protein', sortable: false },
      { text: 'Actions', value: 'name', sortable: false }
    ],
    desserts: [],
    agendaList: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {}
  }),
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'เพิ่มวาระ' : 'แก้ไขข้อมูล'
    },
    termYear () {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_termyear')))
      } else {
        return ''
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.desserts = [
        {
          agendaNum: '1',
          subAgendaNum: '',
          agendaname: 'เรื่องประธานแจ้งเพื่อทราบ (ถ้ามี)',
          shortname: ''
        },
        {
          agendaNum: '2',
          subAgendaNum: '',
          agendaname: 'พิจารณารับรองรายงานการประชุมสามัญผู้ถือหุ้นประจำปี 2560 ซึ่งประชุมเมื่อวันที่ 21 เมษายน 2560 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 1)',
          shortname: ''
        },
        {
          agendaNum: '3',
          subAgendaNum: '',
          agendaname: 'รับทราบรายงานคณะกรรมการบริษัทเกี่ยวกับผลการดำเนินงานประจำปี 2560 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 2)',
          shortname: ''
        },
        {
          agendaNum: '4',
          subAgendaNum: '',
          agendaname: 'พิจารณาอนุมัติงบการเงินประจำปีสิ้นสุด ณ วันที่ 31 ธันวาคม 2560 ซึ่งผ่านการตรวจสอบจากผู้สอบบัญชี (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 2)',
          shortname: ''
        },
        {
          agendaNum: '5',
          subAgendaNum: '',
          agendaname: 'พิจารณาจัดสรรกำไรสุทธิเป็นทุนสำรองตามกฎหมายและการจ่ายเงินปันผลสำหรับผลประกอบการประจำปี 2560',
          shortname: ''
        },
        {
          agendaNum: '6',
          subAgendaNum: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3)',
          shortname: ''
        },
        {
          agendaNum: '6',
          subAgendaNum: '.1',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นายอนิรุทธ์ หิรัญรักษ์',
          shortname: ''
        },
        {
          agendaNum: '6',
          subAgendaNum: '.2',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นางมรกต กุลธรรมโยธิน',
          shortname: ''
        },
        {
          agendaNum: '6',
          subAgendaNum: '.3',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นายมรกต เธียรมนตรี',
          shortname: ''
        },
        {
          agendaNum: '6',
          subAgendaNum: '.4',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นางสาวนฤมล วังศธรธนคุณ',
          shortname: ''
        },
        {
          agendaNum: '7',
          subAgendaNum: '',
          agendaname: 'พิจารณาอนุมัติการกำหนดค่าตอบแทนกรรมการ',
          shortname: ''
        },
        {
          agendaNum: '8',
          subAgendaNum: '',
          agendaname: 'พิจารณาแต่งตั้งผู้สอบบัญชีและกำหนดค่าสอบบัญชีประจำปี 2561 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 6)',
          shortname: ''
        },
        {
          agendaNum: '9',
          subAgendaNum: '',
          agendaname: 'พิจารณาอนุมัติการแก้ไขข้อบังคับ บริษัท อินเทอร์เน็ตประเทศไทย จำกัด(มหาชน) ข้อ 16 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 7)',
          shortname: ''
        },
        {
          agendaNum: '10',
          subAgendaNum: '',
          agendaname: 'พิจารณาเรื่องอื่นๆ (ถ้ามี)',
          shortname: ''
        }
      ]
    },
    editItem (item) {
      this.editedIndex = this.agendaList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.agendaList.indexOf(item)
      this.$swal({
        title: '',
        text: 'คุณต้องการลบรายการที่เลือกอย่างถาวรหรือไม่',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง',
        // confirmButtonColor: 'blue',
        // cancelButtonColor: 'green',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        reverseButtons: true
      }).then((result) => {
        if (!result.value) {
          this.$swal('ข้อมูลถูกลบ', 'คุณได้ลบข้อมูลวาระสำเร็จแล้ว', 'success') && this.agendaList.splice(index, 1)
        }
      })
    },
    //   confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
    // },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.agendaList[this.editedIndex], this.editedItem)
      } else {
        this.agendaList.push(this.editedItem)
      }
      this.close()
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const files = event.target.files
      let filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]
    },
    queryAgenda () {
      this.axios.get(process.env.API + '/getAgendaInYear/' + this.termYear.term + '/' + this.termYear.year).then((response) => {
        // var result = JSON.parse(response.data)
        var result = response.data
        if (response.status === 200) {
          this.agendaList = result
        }
      })
    }
  },
  mounted () {
    this.queryAgenda()
  }
}
</script>

<style lang="css" scoped>
.elevation-1{
  margin: 15px;
}
td{
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/AgendaList.vue